import React from "react";
import { Container } from "react-bootstrap";

function Tutorial() {
    return (
        <Container className="empty-height">
            <h1>Welcome to Tutorial Page</h1>
        </Container>
    );
}

export default Tutorial;
